import { datadogRum } from '@datadog/browser-rum';

let initialized = false;
let replayStarted = false;

export function initDatadogRum() {
  // Only initialize in browser environment and if not already initialized
  if (typeof window === 'undefined' || initialized) return;

  datadogRum.init({
    applicationId: '56052cd0-dca4-4012-906b-f4af42fc58da',
    clientToken: 'puba64d61f451d1525aaafc9b22965a1bb0',
    site: 'us5.datadoghq.com',
    service: process.env.NEXT_PUBLIC_DD_SERVICE || 'tc-programs',
    version: process.env.NEXT_PUBLIC_DD_VERSION,
    env: process.env.NEXT_PUBLIC_DD_ENV || 'development',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    startSessionReplayRecordingManually: true,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });

  initialized = true;
}

export function startSessionReplay() {
  if (typeof window === 'undefined' || !initialized || replayStarted) return;
  datadogRum.startSessionReplayRecording();
  replayStarted = true;
}

export function stopSessionReplay() {
  if (typeof window === 'undefined' || !replayStarted) return;
  // Datadog SDK does not expose a hard stop; restarting a new view effectively ends capture.
  datadogRum.stopSessionReplayRecording?.();
  replayStarted = false;
}
